export const wines = [
  {
    id: 'bordo',
    name: 'Vinho Bordô seco',
    type: 'Tinto',
    description: 'Elaborado 100% com uva Bordô selecionadas. ótimo não só para tomar mas também para fazer sobremesas',
    image: 'https://public.readdy.ai/ai/img_res/88e3668a-0a28-4143-854e-3b5f1fd41bd3.png',
    volume: '2L',
    tag: 'Mais Vendido',
  },
  {
    id: 'pinot',
    name: 'Vinho branco seco Niágara',
    type: 'Branco',
    description: 'Produzido com a uva níagara branca, um vinho de mesa leve e ótimo para acompanhar peixes e frutos do mar',
    image: 'https://public.readdy.ai/ai/img_res/26d119c1-379d-41fc-bdd1-a79945762c35.png',
    volume: '2L',
    tag: '2° mais vendido',
  },
  {
    id: 'rose',
    name: 'Vinho Casca-grossa',
    type: 'Branco',
    description: 'Leveza e frescor em cada taça. encorpado e sabor intenso',
    image: 'https://public.readdy.ai/ai/img_res/d8c97ec7-7f60-48d7-b50e-0ac41b502d69.png',
    volume: '2L',
    tag: 'premium',
  },
  {
    id: 'branco',
    name: 'Vinho tinto suave',
    type: 'Tinto',
    description: 'elaborado com uva bordô, é adocicado e muito aromatico',
    image: 'https://public.readdy.ai/ai/img_res/cc817962-0cb6-4909-abec-b1ec640d9155.png',
    volume: '2L',
    tag: 'adocicado',
  },
  {
    id: 'rose-pet',
    name: 'Vinho Rosé',
    type: 'Rosé',
    description: 'leve no paladar e estéticamente lindo, um vinho diferenciado e ótimo para te acompanhar em dias frios',
    image: 'https://public.readdy.ai/ai/img_res/d2e07303-97dc-49a4-8190-4a77cdfea17c.png',
    volume: '2L',
    tag: 'diferenciado',
  },
];

export const vinegar = {
  name: 'Vinagre Tinto Colonial',
  description: 'Produzido artesanalmente com uvas tintas selecionadas, nosso vinagre colonial preserva todo o sabor e a acidez natural da fruta. Fermentado lentamente pelo método tradicional, é ideal para temperar saladas, marinadas e conservas.',
  image: 'https://storage.readdy-site.link/project_files/05fc8bfd-e456-4aab-b741-4a2713f3ddd4/bf36a7ed-6166-467a-a614-7f880644d436_Captura-de-tela_29-9-2025_21436_.jpeg?v=152b1ef28b2e11e894af235d451b1309',
  options: [
    { volume: '2L', description: 'Embalagem econômica ideal para uso diário na cozinha', tag: 'Econômico' },
    { volume: '740ml', description: 'Tamanho prático para experimentar ou presentear', tag: 'Prático' },
  ],
};

export const juice = {
  name: 'Suco de Uva Integral',
  description: 'Extraído diretamente das uvas, sem adição de água ou açúcar. Puro, natural e cheio de vida.',
  image: 'https://public.readdy.ai/ai/img_res/84dc21df-e7ed-44e3-91af-d9bbfe1994aa.png',
  benefits: [
    { icon: 'ri-heart-pulse-line', title: 'Saúde Cardiovascular', description: 'Rico em resveratrol e flavonoides que protegem o coração e melhoram a circulação sanguínea.' },
    { icon: 'ri-shield-check-line', title: 'Antioxidante Poderoso', description: 'Alto teor de polifenóis que combatem os radicais livres e retardam o envelhecimento celular.' },
    { icon: 'ri-drop-line', title: 'Hidratação Natural', description: 'Excelente fonte de eletrólitos e vitaminas para manter o corpo hidratado e com energia.' },
    { icon: 'ri-brain-line', title: 'Saúde Cerebral', description: 'Compostos bioativos que melhoram a cognição, memória e protegem contra doenças neurológicas.' },
    { icon: 'ri-sun-line', title: 'Vitaminas Essenciais', description: 'Rico em vitaminas C, B1, B2 e B6, essenciais para o bom funcionamento do organismo.' },
    { icon: 'ri-leaf-line', title: '100% Natural', description: 'Sem adição de água, açúcar ou corantes. Puro suco da uva do campo à mesa.' },
  ],
};
